import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {ubicacionesResources, rangosResources, anularTagsResources, observacionesResources,
    forzadosResources, inventarioResources, ajustesResources, metrosResources, pasillosResources,
    controlRespaldoResources, validadorClienteResources} from "../endpoints";
import CircularProgress from "@material-ui/core/CircularProgress";
import {Grid} from "@material-ui/core";

class DialogEliminar extends React.Component{
    constructor(props) {
        super(props);
        if(props.origen === "ListaTags"){
            this.state = {
                iniciar: true,
                boton: "Des-anular"
            };

        }
        else if( props.origen === "RecuperarForzados"){
            this.state = {
                iniciar: true,
                boton: "Recuperar"
            };
        }
        else if( props.origen === "Inventarios"){
            this.state = {
                iniciar: true,
                boton: "Cerrar"
            };
        }
        else if( props.origen === "AjustesAprobar" || props.origen === "AjustesRechazar" || props.origen === "AprobarTodo"){
            this.state = {
                iniciar: true,
                boton: "Confirmar"
            };
        }
        else{
            this.state = {
                iniciar: true,
                boton: "Eliminar"
            };
        }
    };

    handleClickEliminar =()=>{
        if(this.props.origen === "Ubicación"){
            ubicacionesResources.eliminarUbicacion(this.props.id, this.props.idRango).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result=> {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
        else if(this.props.origen === "Rangos"){
            rangosResources.eliminarRango(this.props.id).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result=> {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else {
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
            this.props.handleClose()
        }
        else if(this.props.origen === "ListaTags"){
            const tags={
                tags: this.props.id
            }
            anularTagsResources.desAnularTag(tags).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result=> {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
        else if(this.props.origen === "Observacion"){
            observacionesResources.deleteObservacion(this.props.id).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result=> {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
        else if(this.props.origen === "Forzados"){
            forzadosResources.eliminarForzados().then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result=> {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
        else if (this.props.origen === "RecuperarForzados"){
            forzadosResources.recuperarForzados().then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result=> {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
        else if (this.props.origen === "Inventarios"){
            const estado = "cerrado"
            inventarioResources.modificarEstadoInv(this.props.id,estado).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if(data.message){
                    this.props.refrescar(data.message,data.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
        else if(this.props.origen === "AjustesRechazar"){
            if (this.props.tipo === 'sca' ){
                ajustesResources.rechazarAjuste(this.props.id).then(async response => {
                    if (response) {
                        return await response.json();
                    }
                }).then(data => {
                    if(data.message){
                        this.props.refrescar(data.message,data.severity)
                    }
                    else{
                        throw new Error('Something went wrong ...');
                    }
                }).catch(error=> {
                    this.props.refrescar("Ha ocurrido un error inesperado", "error")
                    console.log(error)
                });
            }
            else{
                ajustesResources.rechazarAjusteCliente(this.props.id).then(async response => {
                    if (response) {
                        return await response.json();
                    }
                }).then(data => {
                    if(data.message){
                        this.props.refrescar(data.message,data.severity)
                    }
                    else{
                        throw new Error('Something went wrong ...');
                    }
                }).catch(error=> {
                    this.props.refrescar("Ha ocurrido un error inesperado", "error")
                    console.log(error)
                });
            }
        }
        else if(this.props.origen === "AjustesAprobar"){
           if (this.props.tipo === 'sca'){
               ajustesResources.aprobarAjuste(this.props.id).then(async response => {
                   if (response) {
                       return await response.json();
                   }
               }).then(data => {
                   if(data.message){
                       this.props.refrescar(data.message,data.severity)
                   }
                   else{
                       throw new Error('Something went wrong ...');
                   }
               }).catch(error=> {
                   this.props.refrescar("Ha ocurrido un error inesperado", "error")
                   console.log(error)
               });
           }
           else{
               ajustesResources.aprobarAjusteCliente(this.props.id).then(async response => {
                   if (response) {
                       return await response.json();
                   }
               }).then(data => {
                   if(data.message){
                       this.props.refrescar(data.message,data.severity)
                   }
                   else{
                       throw new Error('Something went wrong ...');
                   }
               }).catch(error=> {
                   this.props.refrescar("Ha ocurrido un error inesperado", "error")
                   console.log(error)
               });
           }
        }
        else if(this.props.origen === "AprobarTodo"){
            ajustesResources.aprobarTodas(this.props.tipo).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if(data.message){
                    this.props.refrescar(data.message,data.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
        else if(this.props.origen === "Pasillo"){
            pasillosResources.eliminarPasillo(this.props.id).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if(data.message){
                    this.props.refrescar(data.message,data.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
        else if(this.props.origen === "Metro"){
            metrosResources.eliminarMetro(this.props.id).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if(data.message){
                    this.props.refrescar(data.message,data.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
        else if(this.props.origen === "MetrosMultiples"){
            metrosResources.eliminarMetros(this.props.id).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if(data.message){
                    this.props.refrescar(data.message,data.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
        else if(this.props.origen === "ValidadorCliente"){
            validadorClienteResources.deleteValidador(this.props.id).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if(data.message){
                    this.props.refrescar(data.message,data.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
        else if(this.props.origen === "ControlRespaldos"){
            controlRespaldoResources.eliminarControlRespaldo(this.props.id).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if(data.message){
                    this.props.refrescar(data.message,data.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
    }

    getEventType = (event) =>{
        if(event.keyCode === 13){
            this.handleClickEliminar()
        }
        else if(event.keyCode === 27){
            this.props.handleClose()
        }
    }
    componentDidMount(){
        document.addEventListener('keyup', this.getEventType, false);    // third
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.getEventType, false);
    }

    render() {
        return (
            <div>
                <Dialog
                    open={this.state.iniciar}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.props.content}
                        </DialogContentText>
                        <Grid container justifyContent={"center"}>
                            <Grid item>
                                {this.state.progress? <CircularProgress style={{marginTop: '10px',justifySelf: 'center'}}/>: null}
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={this.state.disabled} variant="contained" color="secondary" onClick={this.props.handleClose}>
                            Cancelar
                        </Button>
                        <Button disabled={this.state.disabled} variant="contained" color="primary" onClick={this.handleClickEliminar}>
                            {this.state.boton}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default DialogEliminar;